export const actions = {
    render: {
        renderDetailButton: (callback) => (params) => {
            const {value: data} = params
            const button = document.createElement('a')
            button.innerText = 'Abrir detalle'
            button.style.cursor = 'pointer'

            button.addEventListener('click', (event) => {
                event.stopPropagation()
                callback(data)
            })
            return button
        },
        renderMatchData: (params) => {
            const {value: data} = params

            if (data === '-') return data

            const color = data ? 'vs-chip-primary' : 'vs-chip-danger'

            const container = document.createElement('div')
            container.classList.add('flex', 'items-center', 'h-full')
            
            const chip = document.createElement('div')
            

            chip.classList.add('con-vs-chip', 'h-4', 'w-full', color, 'con-color', 'bg-chip-transparent')
            const labelChip = document.createElement('span')
            labelChip.classList.add('text-chip', 'vs-chip--text')
            labelChip.innerText = data ? "Coincide" : "No coincide"
            chip.appendChild(labelChip)
            
            container.appendChild(chip)

            
            return container
        }
    }
}